import { getRegionConfig } from 'config';
import { Locale, LOCALES } from 'config/constants/locales';
import { Region, REGIONS } from 'constants/shop';
import { NEXT_DEFAULT_LOCALE } from 'utils/i18n/next-locales';

export { REGIONS };

type RouteRegionParam = string | string[] | undefined;

export const getRegionFromRouteParam = (region: RouteRegionParam): Region => {
  const param = (Array.isArray(region) ? region[0] : region)?.toLowerCase();

  switch (param) {
    case Region.CH:
    case 'ch':
      return Region.CH;
    case Region.NL:
    case 'nl':
      return Region.NL;
    case Region.DE:
    case 'de':
    default:
      return Region.DE;
  }
};

export const getLocaleFromNextLocale = (
  region: RouteRegionParam,
  locale: string | undefined
): Locale => {
  if (
    locale &&
    locale !== NEXT_DEFAULT_LOCALE &&
    Object.values(LOCALES).includes(locale as Locale)
  ) {
    return locale as Locale;
  }

  return getRegionConfig(getRegionFromRouteParam(region)).locale;
};
